import { ResolvedScope } from '@/types/apiKey';
import { pluralize } from '@/utils/stringUtils';

import styles from './apiKeysPanel.module.scss';


type AssetScopeKey = Exclude<keyof ResolvedScope, 'mirror' | 'full_access'>;

const KIND_LABEL: Record<AssetScopeKey, string> = {
  constellations: 'constellation',
  secrets: 'secret',
  evaluations: 'evaluation',
  api_keys: 'API key'
};

function describeAsset( bucketName: AssetScopeKey, scope: ResolvedScope ): string[] {
  const bucket = scope[bucketName];
  if ( !bucket ) return [];
  const noun = KIND_LABEL[bucketName];
  const parts: string[] = [];
  if ( bucket.write?.length ) parts.push( `Write: ${ pluralize( noun, bucket.write.length ) }` );
  if ( bucket.invoke?.length ) parts.push( `Invoke: ${ pluralize( noun, bucket.invoke.length ) }` );
  if ( bucket.read?.length ) parts.push( `Read: ${ pluralize( noun, bucket.read.length ) }` );
  return parts;
}

export function ScopeSummary( { scope }: { scope?: ResolvedScope } ) {
  if ( !scope ) return <span className={ styles.muted }>—</span>;
  if ( scope.full_access ) return <span>Full access</span>;
  if ( scope.mirror ) return <span>Mirror my access</span>;

  const parts = [
    ...describeAsset( 'constellations', scope ),
    ...describeAsset( 'secrets', scope ),
    ...describeAsset( 'evaluations', scope ),
    ...describeAsset( 'api_keys', scope )
  ];

  if ( parts.length === 0 ) return <span className={ styles.muted }>No scope</span>;
  return <span>{ parts.join( ' · ' ) }</span>;
}
